<div class="auth-container reset-success-container">
  <div>
    <h1 class="primary-font-semibold heading">{{ 'authentication.reset_success' | translate }}</h1>
    <p class="primary-font-medium form-description">
      {{ 'authentication.reset_success_details' | translate }}
    </p>
  </div>
  <div class="form-container">
    <button
      class="auth-button primary-button custom-button rounded-pill primary-font-medium"
      (click)="redirectToSignIn()"
    >
      {{ 'authentication.lets_sign_in_button' | translate }}
    </button>
  </div>
</div>
